<template>
  <div class="text-center document-element" style="position: relative; !important;">
    <button type="button" class="btn btn-secondary btn-sm handle"
      v-if="! showDrag && doc.document_folder_id"
      @click="removeDocumentFromFolder"
    >
      <i class="fa fa-folder-minus"></i>
    </button>
    <gallery-thumb :file="doc.path" :description="false"
      @startDrag="startDrag"
      @endDrag="endDrag"
    />
    <button type="button" class="btn btn-secondary btn-sm delete-image"
      @click="$emit('deleteImage', doc.id)"
    >
      <i class="fa fa-trash-alt"></i>
    </button>
  </div>
</template>

<script>
  export default {
    props: ['doc', 'showDrag'],
    data() {
      return {
      }
    },
    methods: {
      startDrag(event) {
        this.$store.commit('startDrag', {
          jsDocElement: this.doc,
        })
      },
      endDrag() {
        this.$store.commit('endDrag')
      },
      removeDocumentFromFolder () {
        this.$store.dispatch('removeDocumentFromFolder', this.doc).then(() => this.$emit('moveOutOfFolder', this.doc))
      },
    },
  }
</script>

<style scoped>
.delete-image {
  position: absolute;
  top: -12px;
  right: 52%;
}
.handle {
  position: absolute;
  top: -12px;
  left: 52%;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/DocumentElement.vue